<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"> </p>
<p class="p4"><b>SIX</b></p>
<p class="p4"><b>(Approximately)</b></p>
<p class="p4"><b>MONTHS</b></p>
<p class="p4"><b>(For Lack of Better Word)<span class="Apple-converted-space"> </span></b></p>
<p class="p4"><b>LATER</b></p>
<p class="p3"><b></b> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section11.vue?77bc17d7